<div class="radio-list mt-3">
  <label class="radio-row">
    <input type="radio" name="twoFaMethod" value="email" [checked]="selected2FA === 'email'" (click)="on2FAChange('email', $event)" class="radio-native" />
    <span class="radio-dot"></span>
    <span>Email</span>
  </label>
  <label class="radio-row">
    <input type="radio" name="twoFaMethod" value="sms" [checked]="selected2FA === 'sms'" (click)="on2FAChange('sms', $event)" class="radio-native" />
    <span class="radio-dot"></span>
    <span>SMS</span>
  </label>
  <label class="radio-row">
    <input type="radio" name="twoFaMethod" value="voice" [checked]="selected2FA === 'voice'" (click)="on2FAChange('voice', $event)" class="radio-native" />
    <span class="radio-dot"></span>
    <span>Voice call</span>
  </label>
</div>
